/**
 * Represents a default title
 */
export const APP_NAME = 'SHE';

/**
 * List of page titles
 */
export const PAGE_TITLES = {
  dashboard: {
    index: APP_NAME +  ' - Dashboard',
  },
  reviews: {
    index: APP_NAME +  ' - Encuestas',
    show: APP_NAME  + ' - Encuesta - %ID%'
  },
  expirations: {
    index: APP_NAME +  ' - Vencimientos',
  },
  repairs: {
    index: APP_NAME +  ' - Reparaciones',
    show: APP_NAME  + ' - Reparación - %ID%'
  },
  extinguishers: {
    index: APP_NAME +  ' - Extintores',
    show: APP_NAME  + ' - Extintor - %ID%',
    new: APP_NAME  + ' - Extintor - Nuevo',
  },
  positions: {
    index: APP_NAME +  ' - Puestos',
    show: APP_NAME  + ' - Puesto - %ID%',
    new: APP_NAME  + ' - Puesto - Nuevo',
    edit: APP_NAME  + ' - Puesto - %ID% - Editar',
  },
  users: {
    index: APP_NAME +  ' - Usuarios',
    show: APP_NAME  + ' - Usuario - %ID%',
    new: APP_NAME  + ' - Usuario - Nuevo',
    edit: APP_NAME  + ' - Usuario - %ID% - Editar',
  },
  public: {
    login: APP_NAME +  ' - Login',
    reset: APP_NAME  + ' - Resetear contraseña',
    forgot: APP_NAME  + ' - Restablecer contraseña',
  },
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/models/title.interface.ts